<script>
// import Base from '@/layouts/main.vue';

export default {
  name: "app",
  components: {
    // Base,
  },
  mounted() {
    // document.querySelector("html").setAttribute('dir', 'rtl')
  },
};
</script>

<template>
  <RouterView />
</template>
